<template>
  <v-tooltip right>
    <template v-slot:activator="{ on, attrs }">
      <v-icon color="primary" dark v-bind="attrs" v-on="on" small>
        mdi-help-circle
      </v-icon>
    </template>
    <span>{{ texto }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: "Tooltip",
  props: {
    texto: {
      type: String,
      default: "",
    },
  },
};
</script>
